import { useMutation } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../../../services/queryClient";

export const useVerifyOTPMutation = (otp: string) => {
  const token = localStorage.getItem("W2ST_TUTOR_TOKEN");

  return useMutation(
    () =>
      axiosInstance
        .post(
          "tutors/verify-otp",
          { otp: otp },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res: any) => res.data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries("gettutor");
      },
      onError: (error: any) => {
        message.error(
          error?.response?.data?.message
        );
      },
    }
  );
};
